import { action, computed } from "mobx";
import {
  defaultSelectedTreatmentsDetails,
  SelectedTreatmentsDetails,
} from "../domain/selectedTreatments";
import { StoreBase } from "./storeBase";

export class SelectedTreatmentStore extends StoreBase<SelectedTreatmentsDetails> {
  constructor() {
    super(() => null);
  }
  @computed
  get selectedTreatments(): SelectedTreatmentsDetails {
    return this.data || defaultSelectedTreatmentsDetails();
  }
  @action setSelectedTreatments(selectedTreatments: SelectedTreatmentsDetails) {
    this.data = selectedTreatments;
  }
}
